// app/redux/sagas/workDaysSaga.js
import {API_BASE_URL, extractErrorMessage, getRequest, putRequest} from "../../../api";

import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    GET_WORKDAYS_CONFIG_REQUEST,
    UPDATE_WORKDAYS_CONFIG_REQUEST,
    GET_CALENDAR_SETTINGS_REQUEST,
    UPDATE_CALENDAR_SETTINGS_REQUEST,

    setWorkDaysLoading,

    getWorkdaysConfigSuccess,
    getWorkdaysConfigFail,
    updateWorkdaysConfigSuccess,
    updateWorkdaysConfigFail,

    getCalendarSettingsSuccess,
    getCalendarSettingsFail,
    updateCalendarSettingsSuccess,
    updateCalendarSettingsFail,
} from "../actions/workDaysActions";




// -------------------- WORKERS --------------------

export function* getWorkdaysConfigSaga() {
    const url = `${API_BASE_URL}/api/work-calendar/all/workdays`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setWorkDaysLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getWorkdaysConfigSuccess(resp.data || null));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement jours de travail");
        yield put(getWorkdaysConfigFail(msg));
    } finally {
        yield put(setWorkDaysLoading(false));
    }
}

export function* updateWorkdaysConfigSaga(action) {
    const url = `${API_BASE_URL}/api/work-calendar/workdays`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setWorkDaysLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            token,
            data: action.payload,
            headers: { uid },
        });

        yield put(updateWorkdaysConfigSuccess(resp.data || null));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Paramètres jours de travail enregistrés",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur enregistrement jours de travail");
        yield put(updateWorkdaysConfigFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setWorkDaysLoading(false));
    }
}

export function* getCalendarSettingsSaga(action) {
    const { year, country } = action.payload || {};
    const url = `${API_BASE_URL}/api/work-calendar/holidays/${year}?country=${country || "MA"}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setWorkDaysLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCalendarSettingsSuccess(resp.data || null));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement jours fériés");
        yield put(getCalendarSettingsFail(msg));
    } finally {
        yield put(setWorkDaysLoading(false));
    }
}

export function* updateCalendarSettingsSaga(action) {
    const { year, country, data } = action.payload || {};
    const url = `${API_BASE_URL}/api/work-calendar/holidays/${year}?country=${country || "MA"}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setWorkDaysLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            token,
            data,
            headers: { uid },
        });

        yield put(updateCalendarSettingsSuccess(resp.data || null));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Paramètres jours fériés enregistrés",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur enregistrement jours fériés");
        yield put(updateCalendarSettingsFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setWorkDaysLoading(false));
    }
}

